export const ECHARTS_COLOR_PALETTE = [
    '#5470c6',
    '#91cc75',
    '#fac858',
    '#ee6666',
    '#73c0de',
    '#3ba272',
    '#fc8452',
    '#9a60b4',
    '#ea7ccc',
    '#d87c7c',
    '#919e8b',
    '#d7ab82',
    '#61a0a8',
    '#efa18d',
] as const


export enum EchartsDecalPattern {
    None = 0,
    Lines45,
    Rectangles,
    Circles,
}

export const ECHARTS_DECAL_PATTERNS = {
    [EchartsDecalPattern.None]: {
        symbol: 'none',
    },
    [EchartsDecalPattern.Lines45]: {
        symbol: 'rect',
        rotation: -0.75,
        dashArrayX: [1, 0],
        dashArrayY: [4, 3],
    },
    [EchartsDecalPattern.Rectangles]: {
        symbol: 'rect',
        dashArrayX: [
            [0, 6, 6, 0],
            [6, 6],
        ],
        dashArrayY: [6, 0],
    },
    [EchartsDecalPattern.Circles]: {
        symbol: 'circle',
        dashArrayX: [
            [8, 8],
            [0, 8, 8, 0],
        ],
        dashArrayY: [6, 0],
    },
}